import type { UseQueryResult } from "@tanstack/react-query";
import type { Box, FactBox, ListBox, Read, TaskBox } from "@/components/ui/box.schema";
import { historyCopy } from "./history-copy";

/** The kit's erased Box type; the area's typed callbacks retain their own read. */
export function historyBox<T, R = never>(box: FactBox<T> | ListBox<T, R> | TaskBox<T>): Box {
  return box as unknown as Box;
}

export function historyRead<T>(query: UseQueryResult<T>): Read<T> {
  const retry = () => { void query.refetch(); };
  if (query.data !== undefined && !query.isPlaceholderData) {
    const readAt = new Date(query.dataUpdatedAt).toISOString();
    return query.isError
      ? { status: "stale", last: query.data, readAt, sentence: historyCopy.stale, refresh: retry }
      : { status: "ready", value: query.data, readAt };
  }
  return query.isError
    ? { status: "failed", sentence: historyCopy.failed, retry }
    : { status: "loading" };
}
